import { useLocalStorage } from "react-use";

export const useRememberMe = () => {
  const [rememberedEmail, setRememberedEmail] = useLocalStorage<string>(
    "rememberedEmail",
    "",
  );

  return {
    rememberedEmail,
    setRememberedEmail,
  };
};
